import { Card, Grid, styled, useTheme } from '@mui/material';
import { Fragment, useState } from 'react';
import Campaigns from './shared/Campaigns';
import DoughnutChart from './shared/Doughnut';
import RowCards from './shared/RowCards';
import StatCards from './shared/StatCards';
import StatCards2 from './shared/StatCards2';
import TopSellingTable from './shared/TopSellingTable';
import UpgradeCard from './shared/UpgradeCard';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DoughnutChartBooking from './shared/DoughnutChartBooking';
import LastBooking from './shared/LastBooking';
import {
	productAjaxDispatch,
	showcustomerDispatch,
	showOrderDispatch,
	showProductDispatch,
} from '../../../reducers/HomeReducer';
import './dash.css';
import { addCartRowNew, removeSelectedCartNew } from 'reducers/UiReducer';

const ContentBox = styled('div')(({ theme }) => ({
	margin: '30px',
	[theme.breakpoints.down('sm')]: { margin: '16px' },
}));

const Title = styled('span')(() => ({
	fontSize: '1rem',
	fontWeight: '500',
	marginRight: '.5rem',
	textTransform: 'capitalize',
}));

const SubTitle = styled('span')(({ theme }) => ({
	fontSize: '0.875rem',
	color: theme.palette.text.secondary,
}));

const H4 = styled('h4')(({ theme }) => ({
	fontSize: '1rem',
	fontWeight: '500',
	marginBottom: '16px',
	textTransform: 'capitalize',
	color: theme.palette.text.secondary,
}));

const Shopping = () => {
	const { palette } = useTheme();
	const { loginInfo, customer, product, order, productAjax } = useSelector(
		(state) => state.home
	);
	const { cart } = useSelector((state) => state.ui);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	console.log('productAjax', productAjax);
	const [isClicked, setIsClicked] = useState(false);
	useEffect(() => {
		let form = {
			keywords: '',
			limits: 100,
		};
		dispatch(productAjaxDispatch(form));
		dispatch(showProductDispatch());
	}, []);
	return (
		<>
			<div
				clasName='page ps'
				style={{
					maxHeight: '100vh',
					overflowY: 'auto',
					overflowX: 'hidden',
					scrollbarWidth: 'thin',
					scrollbarColor: '#888 #f5f5f5',
					padding: 20,
				}}></div>
		</>
	);
};

export default Shopping;
